export function downloadCSVTemplate(): void {
  const csvContent = `first,last,id,throws,bats,number
    ##John,##Doe,CSB:smithj1,Right,Left,23
    ##Jane,##Smith,CSS:doej1,Left,Right,7
    ##Michael,##Brown,PG#:1234134132,Right,Switch,42
    ##Ryan,##Johnson,,Right,Switch,15`;
  const blob: Blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const url: string = URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "player_template.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
